import { config } from "../utils/config";
import { getQueryParam } from "../utils/url";

export const useComponentId = () => {
    if (!config.isTrustpilot) {
        return getQueryParam('origCompId') || getQueryParam('compId');
    }

    return '123';
};